import { client } from "@/config/client"

export interface CreateByDocumentPayload {
  type: "document"
  learningPathId: string
  documentId: string
  fromPage: number
  toPage: number
}

export interface CreateByThemePayload {
  type: "input"
  learningPathId: string
  input: string
}

type Payload = CreateByDocumentPayload | CreateByThemePayload

const create = (payload: Payload) => {
  return client.post("/v1/deck-sets", payload)
}

export default create
